import React from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'
import QtyInputPlusMinus from '../../Shared/QtyInputPlusMinus'
import ConvertQuantity from '../../Shared/ConvertQuantity'

const item = { categoryId: '', brandId: '', itemId: '', quantity: 0 }

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <fieldset className="fieldset">
        <legend>اطلاعات کالاهای وارد شده به انبار</legend>

        <table className="table validator-table">
          <thead>
            <tr>
              <th className="text-center">ردیف</th>
              <th className="text-center">دسته بندی</th>
              <th className="text-center">برند</th>
              <th className="text-center">نام کالا</th>
              <th className="text-center">کد کالا</th>
              <th className="text-center">کد کوتاه کالا</th>
              {/* <th className="text-center">موجودی انبار</th> */}
              <th className="text-center">مقدار وارد شده</th>
              {/* <th className="text-center">مقدار مورد نیاز (واحد فرعی)</th> */}
              {/* <th className="text-center">واحد فرعی</th> */}
              {/* <th className="text-center">درج مغایرت</th> */}
            </tr>
          </thead>
          <tbody>
            {values.items &&
              values.items.map((item, index) => (
                <tr key={'p-' + index}>
                  <td>{index + 1}</td>
                  <td>
                    {values.items[index].product &&
                      values.items[index].product.category.name}
                  </td>
                  <td>
                    {values.items[index].product &&
                      values.items[index].product.brand.name}
                  </td>
                  <td>
                    {values.items[index].product &&
                      values.items[index].product.name}
                  </td>
                  <td>
                    {values.items[index].product &&
                      values.items[index].product.extraCode}
                  </td>
                  <td>
                    {values.items[index].product &&
                      values.items[index].product.shortExtraCode}
                  </td>
                  {/* <td>
                  <div className="flex-col flex-center">
                    <span style={{ marginBottom: 10 }}>
                      {values.items[index].unitProductQuantity} {values.items[index].product ? '(' + measurementTypes.filter(el => el.value === values.items[index].product.measurementType)[0].label + ')' : ''}
                    </span>
                    {values.items[index].product && values.items[index].product.conversionUnit ?
                      <span>
                        {(Number((values.items[index].unitProductQuantity / values.items[index].product.conversionUnit).toFixed(3)) + (values.items[index].product.subMeasurementType !== undefined
                          ? ' (' + measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0].label + ')'
                          : ''))}
                      </span>
                      : ''}
                  </div>
                </td> */}
                  <td>
                    <div className="flex-col flex-center">
                      {values.items[index].product ? (
                        <MeasurementTypeDoubleBox
                          product={values.items[index].product}
                          value={values.items[index].quantity}
                          sign="+"
                          // onlySub={true}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  </td>
                  {/* <td>
                  <QtyInputPlusMinus
                    // defaultValue={values.items[index].subExtraQuantity}
                    measurementType={values.items[index].product && values.items[index].product.measurementType}
                    subMeasurementType={values.items[index].product && values.items[index].product.subMeasurementType}
                    conversionUnit={values.items[index].product && values.items[index].product.conversionUnit}
                    onChange={(val, subVal) => {

                      // if (subVal) {

                      // if (val <= values.items[index].unitProductQuantity) {
                      setFieldValue(`items[${index}][subExtraQuantity]`, subVal)
                      // } else {
                      //   setFieldValue(`items[${index}][subExtraQuantity]`, undefined)
                      //   setFieldValue(`items[${index}][extraQuantity]`, undefined)
                      // }

                      // } else {
                      //   setFieldValue(`items[${index}][subExtraQuantity]`, undefined)
                      // }

                      setFieldValue(`items[${index}][extraQuantity]`, val)

                    }}
                  />
                  <ErrorMessage component={ErrorPopUp} name={`items[${index}].extraQuantity`} style={{ margin: '0 auto' }} />
                </td> */}
                  {/* <td>
                  {values.items[index].product && values.items[index].product.subMeasurementType != undefined && measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0] ? '(' + measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0].label + ')' : ''}
                </td> */}
                </tr>
              ))}
          </tbody>
        </table>
      </fieldset>
    </div>
  </div>
)
